<nz-header class="section-header">
  {{ "Veles" | translate }}
</nz-header>

@for (m of modules; track m.path) {
  @if (m.path === componentPaths.dn4) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="12"
      [historyItems]="getTemplateItems(12)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.eq5d) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="13"
      [historyItems]="getTemplateItems(13)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.mobid) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="14"
      [historyItems]="getTemplateItems(14)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.painad) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="15"
      [historyItems]="getTemplateItems(15)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  @if (m.path === componentPaths.pacslac2) {
    <app-questionnaire-history-table
      [id]="m.path"
      [questionnaireTemplateId]="16"
      [historyItems]="getTemplateItems(16)"
      [currentVisitId]="currentVisitId()"
      [isLoading]="overviewLoading"
      [error]="overviewError"
      [showAddButton]="isVisitMode() && !readonlyMode"
      (addRequested)="openVisitQuestionnaire($event)"
      (submissionSelected)="openQuestionnaireSubmission($event)"
      (questionnaireDeleted)="handleVisitQuestionnaireSubmitted()"
    />
  }
  <!-- Remaining Veles questionnaires (PD-Q) are scaffolded under
       pilot-questionnaires/veles-questionnaires/ and will get their own
       app-questionnaire-history-table block here once implemented. -->
}